import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Modal,
  Form,
  Input,
  Tag,
  Upload as UploadAntd,
  Image,
  DatePicker,
  Select,
  Switch,
  Popconfirm,
  Space,
  Tooltip,
  InputNumber,
  Checkbox,
  Typography,
} from "antd";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import React, { useState, useEffect, useRef, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import useRequest from "../hooks/useRequest";
import { ShowToast, Severty } from "../helper/toast";
import Main from "../components/layout/Main";
import useDebounce from "../hooks/useDebounce";
import Noimage from "../assets/images/noimage_newww.png";
import * as XLSX from "xlsx";
import moment, { period } from "moment";
import apiPath from "../constants/apiPath";
import {
  CheckCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  EyeOutlined,
  FilterFilled,
  PlusOutlined,
  StopOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { S3Client, PutObjectCommand } from "@aws-sdk/client-s3";
import PhoneinputField from "../components/PhoneInputField";
import { Upload } from "@aws-sdk/lib-storage";
import lang from "../helper/lang";
import SingleImageUpload from "../components/SingleImageUpload";
import notfound from "../assets/images/not_found.png";
import { Option } from "antd/lib/mentions";
import SuspendIcon from "../assets/images/suspend-main-icon.svg";
import CheckImgIcon from "../assets/images/activee-main-icon.svg";
import { Eye, Pencil, Trash2 } from "lucide-react";

const { RangePicker } = DatePicker;
const { Text } = Typography;

const Search = Input.Search;
const s3Config = {
  region: "us-east-1",
  credentials: {
    accessKeyId: "IJTXH751MBXUWMTWM0SF",
    secretAccessKey: "lfTPRJ2PqAxsp3poTW9YlHktgaL1cFkLup8LidW9",
  },
  endpoint: "https://api-ap-south-mum-1.openstack.acecloudhosting.com:8080/",
  forcePathStyle: true,
};

const s3Client = new S3Client(s3Config);

let baseURL = apiPath.userSubscriptionManager;

function TransactionManager({ type }) {
  const [subscriptions, setSubscriptions] = useState([]);const [loadingSubscriptions, setLoadingSubscriptions] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [transaction, setTransaction] = useState([]);
  const [searchText, setSearchText] = useState("");
  const { request } = useRequest();
  const [list, setList] = useState([]);
  const [listExport, setListExport] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visibleView, setVisibleView] = useState(false);
  const [provideSession, setProvideSession] = useState(false);
  const [selected, setSelected] = useState();
  const [viewData, setViewData] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [filter, setFilter] = useState();
  const [record, setRecord] = useState();
  const [isRKModalVisible, setIsRKModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [isCustomerDetailsVisible, setIsCustomerDetailsVisible] =
    useState(false);
  const [file, setFile] = useState([]);
  const [viewCommentModelVisible, setViewCommentModelVisible] = useState(false);
  const [selectedPostId, setSelectedPostId] = useState(null);

  const [originalList, setOriginalList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [benefitsModalVisible, setBenefitsModalVisible] = useState(false);
  const [selectedBenefits, setSelectedBenefits] = useState(null);
  const [viewModalVisible, setViewModalVisible] = useState(false);
  const [viewTransactionData, setViewTransactionData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filters, setFilters] = useState({
    status: null,
    sort: null,
    dateRange: null,
    period: null,
    package: null,
  });

  const showModal = (rec) => {
    setRecord(rec);
    setIsModalOpen(true);
  };
  const handleOk = () => {
    handleDelete(record._id);
    setIsModalOpen(false);
  };
  const handleCancel = () => setIsModalOpen(false);

  //------------- Table Columns ------------
  const columns = [
    {
      title: "S. No.",
      key: "serial_no",
      width: 80,
      render: (_, __, index) => {
        const serialNumber =
          (pagination.current - 1) * pagination.pageSize + index + 1;
        return <Text>{serialNumber}</Text>;
      },
    },
    {
      title: "Transaction ID",
      dataIndex: "transaction_id",
      key: "transaction_id",
      render: (transaction_id) => {
        return <div>{transaction_id ? transaction_id : "No"}</div>;
      },
    },

    {
      title: "Transaction Date",
      dataIndex: "created_at",
      key: "created_at",
      sorter: (a, b) =>
        moment(a.created_at).valueOf() -
        moment(b.created_at).valueOf(),
      render: (date) =>
        date ? moment(date).format("DD MMM YYYY, hh:mm A") : "-",
    },

    {
      title: "Customer Name",
      dataIndex: ["user", "full_name"],
      key: "customer_name",
      sorter: (a, b) =>
        (a.user?.full_name || "").localeCompare(
          b.user?.full_name || ""
        ),
      render: (name) => name || "N/A",
    },
    {
      title: "Subscription Name",
      dataIndex: ["package", "name"],
      key: "subscription_name",
      sorter: (a, b) =>
        (a.package?.name || "").localeCompare(
          b.package?.name || ""
        ),
      render: (name) => name || "N/A",
    },
    {
      title: "Subscription Duration",
      dataIndex: ["package", "duration"],
      key: "subscription_duration",
      sorter: (a, b) =>
        (a.package?.duration || "").localeCompare(
          b.package?.duration || ""
        ),
      render: (duration) => duration || "N/A",
    },
    {
      title: "Amount Paid",
      key: "amount_paid",
      dataIndex: "amount_paid",
      sorter: (a, b) => {
        const priceA = parseFloat(a.amount_paid) || 0;
        const priceB = parseFloat(b.amount_paid) || 0;
        return priceA - priceB;
      },
      render: (_, { amount_paid }) => {
        return <div>{amount_paid ? amount_paid : "No"}</div>;
      },
    },
    {
      title: "Status",
      dataIndex: "payment_status",
      key: "status",
      sorter: (a, b) => {
        const statusA = a.status || "";
        const statusB = b.status || "";
        return statusA.localeCompare(statusB);
      },
      render: (status) => {
        return (
          <Tag
            color={
              status === "SUCCESS"
                ? "green"
                : status === "PENDING"
                ? "yellow"
                : status === "FAILED"
                ? "red"
                : "blue"
            }
          >
            {status}
          </Tag>
        );
      },
    },

    {
      title: "Action",
      render: (_, record) => {
        return (
          <>
            <Space>
              <Tooltip color="#000" title="View">
                <Button
                  className="button-action-small"
                  onClick={() => handleView(record)}
                  icon={<Eye />}
                />
              </Tooltip>
            </Space>
          </>
        );
      },
    },
  ];

  const showStatusConfirm = (record, toggleStatus) => {
    confirm({
      title:
        record.status === "Active"
          ? "Suspend this plan?"
          : "Activate this plan?",
      content: "Are you sure you want to change the status?",
      okText: "Yes",
      cancelText: "No",
      centered: true,
      okType: record.status === "Active" ? "primary" : "primary",
      onOk() {
        toggleStatus(record);
      },
    });
  };

  const uploadFileToS3 = async (file, bucketName) => {
    const key = "realState/admin" + file.name;
    const params = {
      Bucket: bucketName,
      Key: key,
      Body: file,
    };

    const upload = new Upload({
      client: s3Client,
      params: params,
    });

    try {
      const data = await upload.done();
      return data;
    } catch (err) {
      throw err;
    }
  };

  const handleChangeImage = async (event) => {
    const { file } = event;
    let validateImage =
      file.type.includes("image") && !file.type.includes("svg");

    if (!validateImage) {
      return ShowToast("media not supported " + file.type, Severty.ERROR);
    }
    setFile([file]);
    try {
      const data = await uploadFileToS3(file, "invent-colab-obj-bucket");
      const fileData = {
        uid: file.uid,
        name: file.name,
        status: "done",
        url: data.Location,
        thumbUrl: data.Location,
      };
      setFile([fileData]);
    } catch (err) {
      console.error(err);
    }
  };

  const debouncedSearchText = useDebounce(searchText, 300);

  const navigate = useNavigate();
  const { confirm } = Modal;

  const toggleStatus = (record) => {
    const updatedStatus = record.status === "Active" ? "Suspended" : "Active";

    setLoading(true);
    request({
      url: `${baseURL}/status-change/${record._id}`,
      method: "PUT",
      data: { status: updatedStatus },
      onSuccess: (res) => {
        setLoading(false);
        ShowToast("Status updated successfully", Severty.SUCCESS);
        // Update the list with the new status
        setList((prevList) =>
          prevList.map((item) =>
            item._id === record._id ? { ...item, status: updatedStatus } : item
          )
        );
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error.message || "Failed to update status", Severty.ERROR);
      },
    });
  };

  const handleDelete = (id) => {
    setLoading(true);
    request({
      url: `${baseURL}/${id}`,
      method: "DELETE",
      onSuccess: (data) => {
        setLoading(false);
        setList(list.filter((post) => post._id !== id));
        setRefresh(!refresh);
        ShowToast("Post deleted successfully", Severty.SUCCESS);
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const onSearch = (e) => {
    setSearchText(e.target.value);
    setPagination({ current: 1, pageSize: pagination.pageSize });
  };

  const statusChange = (record, reason) => {
    setLoading(true);
    request({
      url: `${baseURL}/status-change/${record}?`,
      method: "PUT",
      data: {
        optionalReason: reason || "No Reason",
      },
      onSuccess: (data) => {
        setRefresh((prev) => !prev);
        setLoading(false);
        ShowToast(data?.message, Severty.SUCCESS);
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  // Handlers
  const handleTableChange = (paginationInfo, filters, sorter) => {
    setPagination((prev) => ({
      ...prev,
      current: paginationInfo.current,
      pageSize: paginationInfo.pageSize,
    }));
  };

  const showConfirm = (record) => {
    let reason = "";
    setTimeout(() => {
      confirm({
        icon: <ExclamationCircleOutlined />,
        content: (
          <div>
            <p>Are you sure you want change the status?</p>
            <Input
              placeholder="Enter reason (optional)"
              onChange={(e) => (reason = e.target.value)}
              style={{ marginTop: "10px" }}
            />
          </div>
        ),
        onOk() {
          statusChange(record, reason);
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    }, 5);
  };

  useEffect(() => {
    fetchTransaction(pagination);
    fetchSubscriptions()
  }, [filters, refresh, debouncedSearchText, startDate, endDate]);

  // Apply filters whenever filters change
  useEffect(() => {
    if (originalList.length > 0) {
      applyFilters();
    }
  }, [filters]);

  useEffect(() => {
    if (!visibleView) return;
    navigate(`/users-manager/${viewData._id}`);
  }, [visibleView]);
  // ------------- Fetch Subscriptions -----------

  const fetchSubscriptions = useCallback(() => {
    setLoadingSubscriptions(true);

    request({
      url: "/api/admin/subscriptions", // ✅ adjust if your endpoint differs
      method: "GET",
      onSuccess: (res) => {
        setLoadingSubscriptions(false);
        setSubscriptions(res?.data || []);
      },
      onError: () => {
        setLoadingSubscriptions(false);
        ShowToast("Failed to load subscriptions", Severty.ERROR);
      },
    });
  }, [request]);

  // ------------- Fetch Transaction -------------
  const fetchTransaction = useCallback(() => {
    setLoading(true);
    const params = new URLSearchParams();
    if (debouncedSearchText) params.append("search", debouncedSearchText);
    params.append("page", pagination.current);
    params.append("limit", pagination.pageSize);
    if (filters.period) {
      params.append("period", filters.period);
    }
    if (filters.status) {
      params.append("status", filters.status);
    }
    if (filters.package) {
      params.append("package_id", filters.package)
    }
    if (filters.dateRange?.length === 2) {
      try {
        // RangePicker returns dayjs objects which have format method
        params.append("start_date", filters.dateRange[0].format("YYYY-MM-DD"));
        params.append("end_date", filters.dateRange[1].format("YYYY-MM-DD"));
      } catch (e) {
        console.error("Date formatting error:", e);
        // Fallback: try to get date string in different ways
        try {
          if (
            filters.dateRange[0] &&
            typeof filters.dateRange[0].toISOString === "function"
          ) {
            params.append(
              "start_date",
              filters.dateRange[0].toISOString().split("T")[0]
            );
            params.append(
              "end_date",
              filters.dateRange[1].toISOString().split("T")[0]
            );
          } else if (
            filters.dateRange[0] &&
            typeof filters.dateRange[0].toDate === "function"
          ) {
            // If it's a dayjs object with toDate method
            params.append(
              "startDate",
              filters.dateRange[0].toDate().toISOString().split("T")[0]
            );
            params.append(
              "endDate",
              filters.dateRange[1].toDate().toISOString().split("T")[0]
            );
          }
        } catch (fallbackError) {
          console.error("Fallback date formatting also failed:", fallbackError);
        }
      }
    }
    request({
      url: `/api/admin/subscription-transactions?${params.toString()}`,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        let transactionData = [];
        let totalCount = 0;
        let currentPageFromApi = undefined;
        let limitFromApi = undefined;

        if (data?.data) {
          // Common shapes: { data: { users, pagination } } or { data: { docs, totalDocs } }
          if (Array.isArray(data.data)) {
            transactionData = data.data;
          }

          const meta = data.data.pagination || data.pagination || {};
          totalCount =
            meta.totalCount ?? meta.total ?? data.data.totalDocs ?? 0;
          currentPageFromApi = meta.currentPage ?? meta.page ?? meta.pageNumber;
          limitFromApi = meta.limit ?? meta.pageSize;
        } else if (Array.isArray(data)) {
          transactionData = data;
          totalCount = data.length;
        }
        setOriginalList(transactionData);
        setTransaction(Array.isArray(transactionData) ? transactionData : []);
        setPagination((prev) => ({
          ...prev,
          total: totalCount,
          current: currentPageFromApi ?? prev.current,
          pageSize: limitFromApi ?? prev.pageSize,
        }));
      },
      onError: (error) => {
        setLoading(false);
        setTransaction([]);
        setPagination((prev) => ({ ...prev, total: 0 }));
        ShowToast("Failed to fetch users", Severty.ERROR);
      },
    });
  }, [
    filters,
    debouncedSearchText,
    pagination.current,
    pagination.pageSize,
    request,
  ]);

  const handleChangeDate = (e) => {
    setStartDate();
    setEndDate();
    setPagination((prev) => ({ ...prev, current: 1 }));
    if (e && e.length > 0) {
      setStartDate(moment(e[0]._d).format("YYYY-MM-DD"));
      setEndDate(moment(e[1]._d).format("YYYY-MM-DD"));
    }
  };

  const handleFilterChange = (filterType, value) => {
    setFilters((prev) => ({ ...prev, [filterType]: value }));
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  const clearAllFilters = () => {
    setFilters({
      status: null,
      sort: null,
      dateRange: null,
      period: null,
      package: null,
    });
    setFilteredList(originalList);
    setSearchText("");
    setPagination((prev) => ({ ...prev, current: 1 }));
    ShowToast("All filters cleared successfully", Severty.SUCCESS);
  };

  const applyFilters = () => {
    let filteredData = originalList;

    // period filter
    if (filters.period && filters.period !== "") {
      filteredData = filteredData.filter(
        (item) => item.period === filters.period
      );
    }

    // Status filter
    if (filters.status && filters.status !== "") {
      filteredData = filteredData.filter(
        (item) => item.status === filters.status
      );
    }

    setFilteredList(filteredData);
    setList(filteredData);
  };

  const getActiveFiltersCount = () => {
    return Object.values(filters).filter((value) => {
      // null / undefined
      if (value === null || value === undefined) return false;

      // empty string
      if (typeof value === "string" && value.trim() === "") return false;

      // empty array (RangePicker case)
      if (Array.isArray(value) && value.length === 0) return false;

      return true;
    }).length;
  };

  // ---------- Export XLSX File -----------
  const handleExport = () => {
    try {
      console.log("originalList--->", originalList);
      console.log("filteredList--->", filteredList);

      const dataToExport = originalList;

      if (dataToExport.length === 0) {
        ShowToast("No data to export", Severty.ERROR);
        return;
      }

      // Prepare data for export
      const exportData = dataToExport.map((item) => ({
        "Transaction ID": item.transaction_id || "No ID",
        "Transaction Date": item.created_at && moment(item.created_at).isValid()
        ? moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")
        : "N/A",
        "Subscription Name": item.package?.name || "No Name",
        "Amount Paid": item.amount_paid || "Not Paid",
        "Payment Status": item.payment_status || "No Status",
        "Subscription ID": item.package.id || "No ID",
        "Subscription Duration": item.package.duration || "No Duration",
        "Subscription Currency": item.package.currency || "No Currency",
        "Customer ID": item.user?.id || "No ID",
        "Customer Name": item.user?.full_name || "No Name",
        "Customer Email": item.user?.email || "No Email",
        "Customer Phone Number":
          item.user?.mobile
            ? [item.user?.country_code, item.user?.mobile].filter(Boolean).join(" ")
            : "No Mobile",
        // "Customer Username": item.user?.username || "No Username",
        "Customer Status": item.user?.status || "No status",
        "Customer Join Date": item.user?.join_date || "No Date",
      }));

      // Create workbook and worksheet
      const ws = XLSX.utils.json_to_sheet(exportData);

      // Auto-fit column widths
      const colWidths = Object.keys(exportData[0]).map((key) => {
        const maxLength = Math.max(
          key.length,
          ...exportData.map((row) =>
            row[key] ? row[key].toString().length : 0
          )
        );
        return { wch: maxLength + 2 };
      });

      ws["!cols"] = colWidths;

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "User Subscriptions");

      // Generate filename with current date
      const fileName = `User_Subscriptions_${moment().format(
        "YYYY-MM-DD_HH-mm-ss"
      )}.xlsx`;

      // Export file
      XLSX.writeFile(wb, fileName);
      ShowToast("Data exported successfully", Severty.SUCCESS);
    } catch (error) {
      console.error("Export error:", error);
      ShowToast("Failed to export data", Severty.ERROR);
    }
  };

  const handleView = (record) => {
    setViewTransactionData(record);
    setViewModalVisible(true);
  };

  return (
    // <Main>
    <div>
      <div className="tabled">
        <Row>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Transaction Management"
              extra={
                <>
                  {/* <Search
                    size="large"
                    placeholder="Search by Name"
                    onChange={onSearch}
                    title="Search by Name"
                    value={searchText}
                    onPressEnter={onSearch}
                  /> */}

                  {/* <RangePicker
                    style={{ width: "100%" }}
                    placeholder={[
                      lang("Start_Date") || "Start Date",
                      lang("End_Date") || "End Date",
                    ]}
                    value={filters.dateRange}
                    onChange={(dates) => handleFilterChange("dateRange", dates)}
                  /> */}
                  {/* <Button
                    icon={<UploadOutlined />}
                    onClick={handleExport}
                    style={{ marginRight: "8px" }}
                  >
                    Export
                  </Button> */}
                </>
              }
            >
              {/* Filter Panel */}
              <Row style={{ marginBottom: "16px" }}>
                <Col span={24} xl={24}>
                  <Card
                    bordered={false}
                    className="criclebox tablespace mb-24"
                    size="small"
                  >
                    <Row gutter={[16, 16]} align="middle" justify="end">
                      <Col span={24} md={6} lg={4} xl={6}>
                        <Search
                          size="large"
                          placeholder="Search by Customer Name"
                          onChange={onSearch}
                          title="Search by Customer Name"
                          value={searchText}
                          onPressEnter={onSearch}
                        />
                      </Col>

                      <Col span={24} md={6} xl={6}>
                        <RangePicker
                          style={{ width: "100%" }}
                          placeholder={[
                            lang("Start_Date") || "Start Date",
                            lang("End_Date") || "End Date",
                          ]}
                          value={filters.dateRange}
                          onChange={(dates) =>
                            handleFilterChange("dateRange", dates)
                          }
                        />
                      </Col>

                      <Col span={24} md={6} lg={4} xl={4}>
                        <Select
                          placeholder="Select Package"
                          style={{ width: "100%" }}
                          value={filters.package}
                          onChange={(value) =>
                            handleFilterChange("package", value)
                          }
                          allowClear
                        >
                          {subscriptions.map((pkg) => (
                            <Option key={pkg.id} value={pkg.id}>
                              {pkg.name}
                            </Option>
                          ))}
                        </Select>
                      </Col>

                      <Col span={24} md={6} lg={4} xl={4}>
                        <Select
                          placeholder="Select Period"
                          style={{ width: "100%" }}
                          value={filters.period}
                          onChange={(value) =>
                            handleFilterChange("period", value)
                          }
                          allowClear
                        >
                          <Option value="monthly">Monthly</Option>
                          <Option value="yearly">Yearly</Option>
                        </Select>
                      </Col>

                      <Col span={24} md={6} lg={4} xl={4}>
                        <Select
                          placeholder="Select Status"
                          style={{ width: "100%" }}
                          value={filters.status}
                          onChange={(value) =>
                            handleFilterChange("status", value)
                          }
                          allowClear
                        >
                          <Option value="success">Success</Option>
                          <Option value="failed">failed</Option>
                          <Option value="pending">Pending</Option>
                          <Option value="refunded">Refunded</Option>
                        </Select>
                      </Col>

                      <Col>
                        <Button
                          onClick={clearAllFilters}
                          // disabled={getActiveFiltersCount() === 0}
                        >
                          Clear All Filters
                        </Button>
                      </Col>
                      <Col>
                        <Button
                          icon={<UploadOutlined />}
                          onClick={handleExport}
                          style={{ marginRight: "8px" }}
                        >
                          Export
                        </Button>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </Row>
              <div className="table-responsive">
                <Table
                  rowKey={(record) => record._id || record.id}
                  loading={loading}
                  columns={columns}
                  dataSource={transaction}
                  // pagination={{
                  //   current: pagination.current || 1,
                  //   pageSize: pagination.pageSize || 10,
                  //   total: pagination.total || 0,
                  //   showSizeChanger: true,
                  // }}
                  pagination={{
                    current: pagination.current,
                    pageSize: pagination.pageSize,
                    total: pagination.total || 0,
                    showSizeChanger: true,
                    showQuickJumper: false,
                    showTotal: (total, range) =>
                      `${lang("Showing") || "Showing"} ${range[0]}-${
                        range[1]
                      } ${lang("of") || "of"} ${total} ${
                        lang("transactions") || "transactions"
                      }`,
                    pageSizeOptions: ["10", "20", "30", "50"],
                  }}
                  onChange={handleTableChange}
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>

      <Modal
        title="Delete Post"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Delete"
        cancelText="Cancel"
        okButtonProps={{ danger: true }}
        centered
        width={380}
      >
        <div className="select-main-modalss">
          <p>Are you sure you want to delete this post?</p>
        </div>
      </Modal>
      <Modal
        title="Comming Soon......"
        open={isRKModalVisible}
        onOk={() => setIsRKModalVisible(false)}
        onCancel={() => setIsRKModalVisible(false)}
      >
        <p>{modalContent}</p>
      </Modal>

      {/* View Transaction Modal */}
      <Modal
        title="Transaction Details"
        open={viewModalVisible}
        onCancel={() => setViewModalVisible(false)}
        footer={null}
        width={700}
        centered
      >
        {viewTransactionData && (
          <>
            <h3 className="section-title">Transaction Information</h3>
            <div className="list0view-page-main list0view-page-main-gridd">
              <div className="list-view-page-inner">
                <h4>Transaction ID:</h4>
                <h5>{viewTransactionData.transaction_id || "No ID"}</h5>
              </div>
              <div className="list-view-page-inner">
                <h4>Package Name :</h4>
                <h5>{viewTransactionData.package.name || "No Name"}</h5>
              </div>
              <div className="list-view-page-inner">
                <h4>Paid Amount:</h4>
                <h5>{viewTransactionData.amount_paid || "No Name"}</h5>
              </div>
              <div className="list-view-page-inner">
                <h4>Payment Method:</h4>
                <h5>{viewTransactionData.payment_method || "No period"}</h5>
              </div>
              <div className="list-view-page-inner">
                <h4>Transaction Date:</h4>
                <h5>
                  {moment(viewTransactionData.created_at).format(
                    "YYYY-MM-DD"
                  ) || "N/A"}
                </h5>
              </div>
              <div className="list-view-page-inner">
                <h4>Status:</h4>
                <h5>
                  <Tag
                    color={
                      viewTransactionData.payment_status === "SUCCESS"
                        ? "green"
                        : "red"
                    }
                    style={{ borderRadius: "12px", padding: "2px 12px" }}
                  >
                    {viewTransactionData.payment_status || "No Status"}
                  </Tag>
                </h5>
              </div>
            </div>
            <h3 className="section-title" style={{ marginTop: "20px" }}>
              Customer Information
            </h3>
            <div className="list0view-page-main list0view-page-main-gridd">
              <div className="list-view-page-inner">
                <h4>Customer Name:</h4>
                <h5>{viewTransactionData.user.full_name || 0}</h5>
              </div>

              <div className="list-view-page-inner">
                <h4>Customer email:</h4>
                <h5>{viewTransactionData.user.email || 0}</h5>
              </div>

              <div className="list-view-page-inner">
                <h4>Customer Number:</h4>
                <h5>{viewTransactionData.user?.mobile || 1}</h5>
              </div>

              <div className="list-view-page-inner">
                <h4>Join Date:</h4>
                <h5>{viewTransactionData.user.join_date || 0}</h5>
              </div>

              <div className="list-view-page-inner">
                <h4>Customer ID:</h4>
                <h5>{viewTransactionData.user.id || 0}</h5>
              </div>

              <div className="list-view-page-inner">
                <h4>Status:</h4>
                <h5>
                  <Tag
                    color={
                      viewTransactionData.user.status === "Active"
                        ? "green"
                        : "red"
                    }
                    style={{ borderRadius: "12px", padding: "2px 12px" }}
                  >
                    {viewTransactionData.user.status || "No Status"}
                  </Tag>
                </h5>
              </div>
              {viewTransactionData.updated_at && (
                <div className="list-view-page-inner">
                  <h4>Updated Date:</h4>
                  <h5>
                    {moment(viewTransactionData.updated_at).format(
                      "YYYY-MM-DD HH:mm"
                    )}
                  </h5>
                </div>
              )}
            </div>
          </>
        )}
      </Modal>
    </div>
    // </Main>
  );
}

export default TransactionManager;
